import React from 'react'
import { QRCode } from "react-qr-svg";

const QRGenerate = (props) => {

    const downloadQRCode = () => {
        
    }

    return (
        <div>
            <button className="btn btn-flat" onClick={downloadQRCode}>
                <QRCode
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                    level="M"
                    style={{ width: 250 }}
                    value={props.value}
                    id="qrCodeEl"
                />
            </button>
        </div>
    )
}

export default QRGenerate;
